module.exports = __webpack_public_path__ + "img/demo1.c328bd0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zj/demo1.png
// module id = NLi2
// module chunks = 35 36